//Author June Leow
//Date Mar 25th, 2024
import {getReducer, getSetStateFunction, deleteAPICallGenerator, callBackGenerator, showMessage} from '../../../../util/util';
import React, {useReducer, useEffect} from 'react';
import {Card, CardHeader, CardBody, Row, Col, Input} from 'reactstrap';
import Compressor from 'compressorjs';
import Dropzone from 'react-dropzone'
import MySelect from '../../../util/my-select';
import {NavLink} from 'react-router-dom';
import CondoUnitViewFeatures from './condo-unit-view-features';
import HeatingCoolings from './heating-coolings';
import Mechanicals from './mechanicals';
import Garages from './garages';
import Levels from './levels';
//initialize the state
const initialState = {

};


const unitConstructionStatusEnum =[
  {value:'COMPLETE',label:'Complete'},
  {value:'INCOMPLETE_CONSTRUCTION',label:'Incomplete Construction'},
  {value:'INCOMPLETE_RENOVATION_CONSTRUCTION',label:'Incomplete Renovation Construction'}
];

const disabledStyling = {border:'none', background:'#fff', padding:'0',paddingLeft:'2px', height:'auto',WebkitAppearance:'none'};


//reducer function that perform state update
const reducer = getReducer();


const Units  = (props)=>{
  const controller = new AbortController();

  const [, dispatch] = useReducer(reducer,initialState);

  //wrapper function
  const setState = getSetStateFunction(dispatch);

  const apiCallBack = callBackGenerator(setState);
  const httpDelete = deleteAPICallGenerator(props, {signal:controller.signal});

  //run only once when component is loaded
  useEffect(()=>{
    return ()=> controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  //non API call but simpyl manage state
  const numberOnly= (e) => {
    const isControlKey = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"].includes(e.key);
    if (!isControlKey && e.key.match(/[^0-9]/)) {
      e.preventDefault();
    }
  };

  const getCompressRatio = (size)=>{
    let ratio = 0.8;
    size = size/1000/1000;
  
    if(size>=20)
      ratio = 0.05;
    else if(size>=15)
      ratio = 0.05;
    else if(size>=10)
      ratio = 0.1;
    else if(size>=8)
      ratio = 0.2;
    else if(size>=6)
      ratio = 0.4;
    else if(size>=4)
      ratio = 0.5;
    else if(size>=3)
      ratio = 0.6;
    else if(size>=2)
      ratio = 0.7;
  
    return ratio;
  }

  const updateFileDescription = (index, index2, field, description)=>{
    let newUPD = Object.assign({}, props.upd);
    let units = newUPD.property.buildings[props.index].units?newUPD.property.buildings[props.index].units.slice():[];
     let target = units[index][field];
    if(target &&  target[index2]){
      target[index2].description = description;
    }

    newUPD.property.buildings[props.index].units = units;
    props.update(newUPD);
  }

  

  //function trigger for dropzone react.
  //this function contians two list of files, the accepted and rejected file per the configuration
  const onDrop = (acceptedFiles, rejectedFiles, index, field, type='Misc', typeFk=0, description='')=>{
    let existingFiles = [];
    if(acceptedFiles.length>0){
      for(let i=0;i<acceptedFiles.length;i++){
        existingFiles.push(acceptedFiles[i]);
        let name = existingFiles[i].name;
        let token = name.split('.');
        let extension = '';

        if(token.length>0){
          extension = token[token.length-1];
          extension = extension.toLowerCase();
        }

        if(extension!=='png'&&extension!=='jpg'&&extension!=='jpeg'){
          showMessage('error','Please upload only PNG/JPG image.');
        }
        else if((acceptedFiles[i].size/1000/1000)<1 && type!=='FLOOR_PLAN'){
          showMessage('error','Image quality is too low, please use photo that range from 1MB to 50MB.');
        }
        else if((acceptedFiles[i].size/1000/1000)>50){
          showMessage('error','Image size is too large, please use photo that range from 1MB to 50MB.');
        }
        else{
          let compressRatio = getCompressRatio(acceptedFiles[i].size);
          new Compressor(acceptedFiles[i], {
            quality: compressRatio, // 0.6 can also be used, but its not recommended to go below.
            success: (compressedResult) => {
              // compressedResult has the compressed file.
              // Use the compressed file to upload the images to your server.        
              let compressedFile = new File([compressedResult], acceptedFiles[i].name);

              const reader = new FileReader();
              reader.onload = () => {
                const fileAsBinaryString = reader.result;
                let base64 = btoa(fileAsBinaryString);
                let newUPD = Object.assign({}, props.upd);
                let units = newUPD.property.buildings[props.index].units?newUPD.property.buildings[props.index].units.slice():[];
   
                let target = units[index][field];
                console.log(units);
                console.log(index);
                console.log(field);
  
                target.push({name:acceptedFiles[i].name, base64:base64, status:'Pending', size:compressedFile.size, type:type, typeFk:units[index].ID, description:description});
                units[index][field] = target;
                newUPD.property.buildings[props.index].units = units;
                props.update(newUPD);
              }
              reader.readAsBinaryString(compressedFile);
            },
          });
        }
      }
    }
  }

  const removeFile = (field,index, index2)=>{
    let newUPD = Object.assign({}, props.upd);
    let units = newUPD.property.buildings[props.index].units?newUPD.property.buildings[props.index].units.slice():[];
    let target = units[index][field].slice();

    let targetToDelete = target[index2];

    if(targetToDelete.ID && targetToDelete.ID!==-1){
      let successCallBack = ()=>{
        target.splice(index2, 1);
        units[index][field] = target;
        newUPD.property.buildings[props.index].units = units;
        props.update(newUPD);
      };
      successCallBack = successCallBack.bind(this);
      deletePhoto(targetToDelete.ID, props, successCallBack);
    }
    else{
      target.splice(index2, 1);
      units[index][field] = target;
      newUPD.property.buildings[props.index].units = units;
      props.update(newUPD);
    }
  }

  const updateUnitsDetail = (index, field, value)=>{
    let newUPD = Object.assign({}, props.upd);
    let units = newUPD.property.buildings[props.index].units?newUPD.property.buildings[props.index].units.slice():[];
    units[index][field] = value;
    newUPD.property.buildings[props.index].units = units;
    props.update(newUPD);
  }

  const addUnit = ()=>{
    let newUPD = Object.assign({}, props.upd);
    let units = newUPD.property.buildings[props.index].units?newUPD.property.buildings[props.index].units.slice():[];
    units.push({imageFloorPlan:[], unitView:{views:[]}, unitFeatures:[], heatingSystems:[], coolingSystems:[], mechanicalDeficiencies:[], mechanicalUpdates:[], garages:[], levels:[{belowGradeExits:[], atticAccess:[], rooms:[{appliances:{},interiorUpdates:[], interiorDeficiencies:[], plumbingFixtures:[], roomFeatures:[{roomFeatureType:[]}]}]}]});
    newUPD.property.buildings[props.index].units = units;
    props.update(newUPD);
  }

  const removeUnits = (index)=>{
    let newUPD = Object.assign({}, props.upd);
    let units = newUPD.property.buildings[props.index].units?newUPD.property.buildings[props.index].units.slice():[];
    units.splice(index, 1);
    newUPD.property.buildings[props.index].units = units;
    props.update(newUPD);
  }

  //API call
  const deletePhoto = (ID, props, successCallBack) => {
    let callBack = apiCallBack([],[()=>{successCallBack()}])
    httpDelete('uniformPropertyDataset/photo/'+ID, '', 'Oops, something went wrong and could not delete this photo. Please try again later.', callBack);
  }

  //render
  return (<div>
    {props.disabled?null:<div className="align-right">
      <NavLink to="#" onClick={(e)=>addUnit()}><i className="fa fa-plus green-color"/> Add Units</NavLink>
    </div>}
    {
      props.upd.property.buildings[props.index].units.map(
        (unit, index)=>{
          return (<div key={index} id={`unit-${props.index}-${index}`}>
            <Card>
              <CardHeader><i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeUnits(index)}/> Unit {index+1}</CardHeader>
              <CardBody>
                {(props.upd.property.propertyType==='SF' && props.upd.property.buildings[props.index].containsRooms)?<div>
                  <label>{!props.disabled?<font color="red">*</font>:null}Indicate whether this structure is an accessory dwelling unit (ADU). </label>
                  <MySelect
                    type="select"
                    required={!props.disabled}
                    disabled={props.disabled}
                    style={props.disabled?disabledStyling:{}}
                    value={unit.aduIndicator}
                    onChange={(v)=>updateUnitsDetail(index, 'aduIndicator', v)}
                    options={[{label:"True", value:"True"}, {label:"False", value:"False"}]}
                  />
                  <br/>
                </div>:null}

                <br/>
                

                {props.upd.property.propertyType==='CONDO'?<div>
                  <label>{!props.disabled?<font color="red">*</font>:null}What is the unit's current construction status? </label>
                  <MySelect
                    type="select"
                    required={!props.disabled}
                    disabled={props.disabled}
                    style={props.disabled?disabledStyling:{}}
                    value={unit.unitConstructionStatus}
                    onChange={(v)=>updateUnitsDetail(index, 'unitConstructionStatus', v)}
                    options={unitConstructionStatusEnum}
                  />
                  <br/>
                  <label>{!props.disabled?<font color="red">*</font>:null}Identify the floor within the project that the unit's main entrance is located on. The data collector should input the number of the floor for which they pushed in the elevator or exited the stairwell on to enter the unit.</label>
                  <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} required={!props.disabled} pattern="[0-9]*" onKeyDown={numberOnly} type="text" value={unit.floorNumber} onChange={(e)=>updateUnitsDetail(index,'floorNumber', e.target.value)}/>
                  <br/>
                  <label>{!props.disabled?<font color="red">*</font>:null}Indicate whether the unit is located on the top floor.</label>
                  <MySelect
                    type="select"
                    required={!props.disabled}
                    disabled={props.disabled}
                    style={props.disabled?disabledStyling:{}}
                    value={unit.topFloor}
                    onChange={(v)=>updateUnitsDetail(index, 'topFloor', v)}
                    options={[{label:"True", value:"True"}, {label:"False", value:"False"}]}
                  />
                  <br/>
                  <label>{!props.disabled?<font color="red">*</font>:null} Identify the floor of the building where the main entrance of the unit is located.</label>
                  <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} required={!props.disabled} pattern="[0-9]*" onKeyDown={numberOnly} type="text" value={unit.unitMainEntrance} onChange={(e)=>updateUnitsDetail(index,'unitMainEntrance', e.target.value)}/>
                  <br/>
                  <CondoUnitViewFeatures {...props} index={props.index} index2={index}/>
                  <br/>
                </div>:null}
                <HeatingCoolings {...props} index={props.index} index2={index}/>
                <br/>
                <Mechanicals {...props} index={props.index} index2={index}/>
                {props.upd.property.propertyType==='SF' || (props.upd.property.propertyType==='CONDO' && (props.upd.property.buildings[props.index].buildingDesign==='DETACHED'||props.upd.property.buildings[props.index].buildingDesign==='ROWHOUSE_TOWNHOUSE'||props.upd.property.buildings[props.index].buildingDesign==='OTHER'))?
                <Garages {...props} index={props.index} index2={index}/>:null}
                <Levels {...props} index={props.index} index2={index}/>

                <div className="my-divider"/>
                <br/>
                
                
                <br/>
              </CardBody>
            </Card>
            <br/>
          </div>);
        })
    }
  </div>);
}

export default Units;